import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EncuestaSatisfaccionProps, PreguntaSatisfaccion } from 'src/common/encuesta';
import { environment } from 'src/environments/environment';

@Injectable()
export class PreguntaSatisfaccionService {

	private readonly ACCESO_BASE_URL: string = environment.backendUrl + '/encuesta/satisfaccion';
	private readonly FIND_PREGUNTAS_ACTIVAS: string = this.ACCESO_BASE_URL + '/pregunta';
	private readonly ADD_ENCUESTA_SATISFACCION: string = this.ACCESO_BASE_URL;
	private readonly ENCUESTA_SATISFACCION_PROPS: string = this.ACCESO_BASE_URL + '/prop';


	constructor( private http: HttpClient ) {
	}

	findPreguntasSatisfaccionActivas(): Observable<PreguntaSatisfaccion[]> {
		return this.http.get<PreguntaSatisfaccion[]>( this.FIND_PREGUNTAS_ACTIVAS );
	}

	addEncuestaSatisfaccion( preguntaAbrev: string, descripcion: string, mostrar: boolean ): Observable<Object> {
		return this.http.post<Object>( this.ADD_ENCUESTA_SATISFACCION, { preguntaAbrev, descripcion, mostrar } );
	}

	getEncuestaSatisfaccionProps(): Observable<EncuestaSatisfaccionProps> {
		return this.http.get<EncuestaSatisfaccionProps>( this.ENCUESTA_SATISFACCION_PROPS );
	}

}